import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  insuredByCoverage: {
    id: '253AmG',
    description: 'Header text when shipment is insured by ParcelGuard',
    defaultMessage: 'Your shipment is insured by our coverage',
  },
  notInsuredByCoverage: {
    id: 'LNQbvy',
    description: 'Header text when shipment is not insured by ParcelGuard',
    defaultMessage: 'You could be liable for lost or damaged goods',
  },
  noneProviderMessage: {
    id: '8mEm5t',
    description: 'Warning message when no insurance provider is selected',
    defaultMessage: 'Without our coverage, you may face costs for lost or damaged shipments.',
  },
  carrierProviderMessage: {
    id: 'nrRC7s',
    description: 'Promotional message when carrier insurance is selected',
    defaultMessage: 'Save up to 67% compared to traditional carrier insurance with ShipStation.',
  },
  automaticallyInsure: {
    id: 'GnCtg2',
    description: 'Checkbox label to automatically insure all future shipments',
    defaultMessage: 'Automatically insure all future shipments',
  },
  popoverInsurance: {
    id: 'UqRXoM',
    description: 'Popover label for insurance provider when collapsed',
    defaultMessage: 'Insurance: {providerName}',
  },
  popoverInsureAmount: {
    id: 'r/o0IY',
    description: 'Popover label for insured amount when collapsed',
    defaultMessage: 'Insure Amount: {amount}',
  },
  noSelectedPreference: {
    description: 'subheader shown to the user when they have not selected any insurance option preference',
    defaultMessage: 'You have not yet configured a default insurance setting.',
    id: 'VQI4vy',
  },
  applyDecisionCheckboxLabel: {
    description: 'checkbox label for applying the selected option as the default preference',
    defaultMessage: 'Set as default insurance option for future shipments',
    id: 'IO3lvJ',
  },
});
